import { useNavigate } from "react-router-dom";
import { projectSummaries } from "@/projects/projectIndex";
import { trackProjectOpen } from "@/lib/analytics";

export default function ProjectsSection() {
  const navigate = useNavigate();
  const latestProjects = projectSummaries.slice(0, 3);

  const openProject = (project: (typeof projectSummaries)[number]) => {
    void trackProjectOpen(project.id, project.title);
    navigate(`/project/${project.id}`);
  };

  return (
    <section id="projects" className="py-20 md:py-28 lg:py-32 bg-stem-dark">
      <div className="section-padding max-w-6xl mx-auto mb-10 md:mb-14">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
          <div>
            <span className="label text-revelBlue mb-3 block">My Work</span>
            <h2 className="heading-lg text-white">Projects & Experiments</h2>
          </div>
          <button
            onClick={() => navigate("/projects")}
            className="btn-dark text-sm py-2.5 px-5 hidden md:inline-flex whitespace-nowrap"
          >
            View All Projects
            <i className="ri-arrow-right-line" />
          </button>
        </div>
      </div>

      <div className="section-padding max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {latestProjects.map((project) => (
            <div
              key={project.id}
              onClick={() => openProject(project)}
              className="bg-stem-cream rounded-2xl overflow-hidden group cursor-pointer transition-transform duration-300 hover:-translate-y-2"
              role="link"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter") openProject(project);
              }}
            >
              <div className="aspect-square overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
                  <span className="text-xs font-semibold uppercase tracking-wider text-revelBlue leading-snug">
                    {project.category}
                  </span>
                  <span className="text-xs text-stem-gray">{project.date}</span>
                </div>
                <h3 className="text-lg md:text-xl font-bold text-stem-dark mb-2">
                  {project.title}
                </h3>
                <p className="text-sm text-stem-gray leading-relaxed line-clamp-2">
                  {project.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 md:hidden">
          <button
            onClick={() => navigate("/projects")}
            className="btn-dark w-full justify-center text-sm py-2.5 whitespace-nowrap"
          >
            View All Projects
            <i className="ri-arrow-right-line" />
          </button>
        </div>
      </div>
    </section>
  );
}
